import { DomainLayout } from "@/components/layouts/DomainLayout";
import { WrappedView } from "../views/WrappedView";

export const WrappedPage = () => (
  <DomainLayout>
    <WrappedView />
  </DomainLayout>
);
